/**
 * A link from a record, made safe to put in an href.
 *
 * React does not stop a `javascript:` URL in an href, so a website, source or
 * document link saved as `javascript:fetch(…)` ran on the app's own origin
 * when clicked — reading the signed-in session (Oct 2026 audit). Only http and
 * https links are links; anything else renders as plain text with no href.
 */
export function safeHref(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.trim()) return undefined
  try {
    const u = new URL(value.trim())
    return u.protocol === 'https:' || u.protocol === 'http:' ? u.href : undefined
  } catch {
    return undefined
  }
}
